var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{class:['toast', `toast--${_vm.type}`],attrs:{"value":_vm.value,"timeout":7500,"bottom":"","left":"","auto-height":""},on:{"input":_vm.onInput}},[_c('typography',{attrs:{"type":"small-p","no-margin":""}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }